export default "__VITE_ASSET__1c974b31__"